var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZiynetlogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 113,
    viewBox: "0 0 113 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81.4578 0.237793V32.8419H32.9062L59.9468 39.9276L32.44 71.2008V79.6337H0.949219V29.3807L30.6415 0.809222L81.4578 0.237793Z",
    fill: "#FCA311"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4404 112.237V79.6332H81.4582L55.0307 72.5311L81.4582 40.4496V32.8413H112.949V83.0781L83.2567 111.666L32.4404 112.237Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZiynetlogo);
export default __webpack_public_path__ + "static/media/ziynetlogo.863ec31d2f39d6d5a67eacda8579c29f.svg";
export { ForwardRef as ReactComponent };